import gql from "graphql-tag";

const workTimeSymbolMutations = {


    createWorkTimeSymbol: gql`
        mutation CreateWorkTimeSymbol($acronym: String, $name: String, $record: Boolean) {
            createWorkTimeSymbol(acronym: $acronym, name: $name, record: $record) {
                id,
                acronym,
                name,
                record
            }
        }
    `,
    updateWorkTimeSymbol: gql`
        mutation UpdateWorkTimeSymbol($id: ID!, $acronym: String, $name: String, $record: Boolean) {
            updateWorkTimeSymbol(id: $id, acronym: $acronym, name: $name, record: $record) {
                id,
                acronym,
                name,
                record
            }
        }
    `,
};

export default workTimeSymbolMutations;